import { FC, PropsWithChildren } from "react";
import cn from "classnames";
import styles from "./NavTitle.module.scss";
import { NavTitleProps } from "./NavTitle.props";

/**
 * The navigation item title component.
 */
export const NavTitle: FC<PropsWithChildren<NavTitleProps>> = (props: PropsWithChildren<NavTitleProps>): JSX.Element => {
  const { id, testId, className, children } = props;
  const navTitleClasses = cn("nav-title", styles.navTitle, className);

  return (
    <div id={id} data-testid={testId ? `test__${testId}-nav-title` : undefined} className={navTitleClasses}>
      {children}
    </div>
  );
};
